__turbopack_context__.v({
  "root": "Swiper-module-scss-module__m8g_9a__root",
});
